import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Title = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.xl,
    fontWeight: 'bold',
    textAlign: 'center',
  }),
);

export const CurrentRaceWrapper = styled.ul(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: ['repeat(1, 1fr)', 'repeat(1, 1fr)', 'repeat(2, 1fr)'],
    gridGap: defaultTheme.spacing.l,
    marginTop: defaultTheme.spacing.xxl,
  }),
);

export const EmptyText = styled.p(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: ['96px', '96px', '216px'],
    color: defaultTheme.text.gray,
    textAlign: 'center',
  }),
);
